function properties_Reducer(state = [], action) {
    switch (action.type) {
        case 'PROPERTIES/SET':            
            return action.properties;
        case 'PROPERTIES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default properties_Reducer;
